import React from 'react';
import { Popover, Box, ClickAwayListener } from '@mui/material';

export interface CustomPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  disableClickAway?: boolean;
  disableEscapeKeyDown?: boolean;
  anchorOrigin?: {
    vertical: 'top' | 'center' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  transformOrigin?: {
    vertical: 'top' | 'center' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  disablePortal?: boolean;
}

export const CustomPopover: React.FC<CustomPopoverProps> = ({
  anchorEl,
  open,
  onClose,
  children,
  className,
  disableClickAway = false,
  disableEscapeKeyDown = false,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
  disablePortal = false,
}) => {
  const content = <Box>{children}</Box>;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      className={className}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disablePortal={disablePortal}
    >
      {disableClickAway ? (
        content
      ) : (
        <ClickAwayListener onClickAway={onClose}>{content}</ClickAwayListener>
      )}
    </Popover>
  );
};

export default CustomPopover;
